export enum SensorCarbonDioxideTagType {
  BUILDING_CARBON_DIOXIDE = 'building_carbon_dioxide',
}

export enum SensorHumidityTagType {
  STREET_HUMIDITY = 'street_humidity',
  BUILDING_HUMIDITY = 'building_humidity',
}

export enum SensorIlluminanceTagType {
  BUILDING_ILLUMINANCE = 'building_illuminance',
}

export enum SensorKilowattsHourTagType {
  BUILDING_ENERGY = 'building_energy',
  BUILDING_POWER = 'building_power',
  DOMESTIC_ENERGY_GENERAL = 'domestic_energy_general',
  THERMAL_ENERGY_HEAT = 'thermal_energy_heat',
  THERMAL_ENERGY_COOLING = 'thermal_energy_cooling',
  THERMAL_ENERGY_HEAT_AUTO_BILLING = 'thermal_energy_heat_auto_billing',
  THERMAL_ENERGY_COOLING_AUTO_BILLING = 'thermal_energy_cooling_auto_billing',
  DOMESTIC_ENERGY_GENERAL_AUTO_BILLING = 'domestic_energy_general_auto_billing',
}

export enum SensorPeopleFlowTagType {
  PEOPLE_FLOW_IN = 'people_flow_in',
  PEOPLE_FLOW_OUT = 'people_flow_out',
}

export enum SensorTemperatureTagType {
  STREET_TEMPERATURE = 'street_temperature',
  BUILDING_TEMPERATURE = 'building_temperature',
}

export enum SensorVolumeTagType {
  BUILDING_GAS = 'building_gas',
  BUILDING_COLD_WATER = 'building_cold_water',
  BUILDING_HOT_WATER = 'building_hot_water',
  BUILDING_WATER = 'building_water',
  DOMESTIC_WATER_GENERAL = 'domestic_water_general',
  DOMESTIC_HOT_WATER = 'domestic_hot_water',
  DOMESTIC_COLD_WATER = 'domestic_cold_water',
  DOMESTIC_WATER_GENERAL_AUTO_BILLING = 'domestic_water_general_auto_billing',
  DOMESTIC_HOT_WATER_AUTO_BILLING = 'domestic_hot_water_auto_billing',
  DOMESTIC_COLD_WATER_AUTO_BILLING = 'domestic_cold_water_auto_billing',
}

export const CombinedSensorTagType = {
  ...SensorCarbonDioxideTagType,
  ...SensorHumidityTagType,
  ...SensorIlluminanceTagType,
  ...SensorKilowattsHourTagType,
  ...SensorPeopleFlowTagType,
  ...SensorTemperatureTagType,
  ...SensorVolumeTagType,
} as const;

export type SensorTagType = (typeof CombinedSensorTagType)[keyof typeof CombinedSensorTagType];
